import React, { ReactNode } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import { initSideModal } from 'helpers/utils';
import { setSideModalData } from 'store/features/modelSlice';
import { useTranslation } from 'react-i18next';

const defaultProps = {
  modalClassName: '',
  onConfirm: () => {},
  disabled: false,
  cancelButtonProps: {
    label: 'CANCEL',
    hide: false,
  },
  confirmButtonProps: {
    label: 'CONFIRM',
    hide: false,
  },
  onCancel: null,
};
interface IProps {
  children: ReactNode;
  onConfirm: () => void;
  cancelButtonProps?: {
    label: string;
    hide?: boolean;
  };
  confirmButtonProps?: {
    label: string;
    hide?: boolean;
  };
  onCancel?: () => void | null;
}
const CommonLayout: React.FC<IProps> = ({
  children,
  onConfirm = defaultProps.onConfirm,
  cancelButtonProps = defaultProps.cancelButtonProps,
  confirmButtonProps = defaultProps.confirmButtonProps,
  onCancel = defaultProps.onCancel,
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { sideModal } = useAppSelector(state => state.modal);
  const {
    content: { title, subtitle },
  } = sideModal;
  const handleCloseModal = () => {
    if (onCancel) {
      onCancel();
    } else {
      dispatch(setSideModalData(initSideModal));
    }
  };
  return (
    <div className="flex flex-col w-full h-full">
      {/*Modal header*/}
      <div className="modal-header flex justify-between items-center bg-grey4 px-10 py-8 rounded-t-2xl">
        <div className="modal-header">
          <h3 id="modal-title" className="text-xl font-semibold text-black2 ">
            {title}
          </h3>
          <p className="text-base text-secondaryLight font-medium flex-1">{subtitle}</p>
        </div>
        <button
          type="button"
          className="text-grey4 bg-light1 rounded-full text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
          data-modal-hide="add-user-modal"
          onClick={() => handleCloseModal()}
        >
          <svg
            className="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">Close modal</span>
        </button>
      </div>
      <div className="flex flex-col flex-1 overflow-y-auto overflow-x-hidden">{children}</div>
      {/*Modal footer*/}
      <div className="modal-footer bg-white flex items-center justify-center p-6 space-x-2 border-t border-gray-200 rounded-b-2xl">
        {!confirmButtonProps?.hide ? (
          <button
            data-modal-hide="add-user-modal"
            type="button"
            className="cursor-pointer rounded-1 min-w-[220px] text-white px-6 py-2 bg-primaryDark"
            onClick={onConfirm}
          >
            {t(`${confirmButtonProps.label}`)}
          </button>
        ) : (
          <></>
        )}
        {!cancelButtonProps?.hide ? (
          <button
            data-modal-hide="add-user-modal"
            type="button"
            className="cursor-pointer rounded-1 min-w-[220px] text-white px-6 py-2 bg-black2"
            onClick={() => handleCloseModal()}
          >
            {t(`${cancelButtonProps.label}`)}
          </button>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default CommonLayout;
